import { useParams, Link } from 'react-router-dom'
import Seo from '../components/Seo'
import Breadcrumbs from '../components/Breadcrumbs'
import { categoryBySlug, calcBySlug, calcsInCategory } from '../data/calculators'

// Dispatches a /calculators/:slug URL to either a category hub or a
// (not-yet-built) calculator's "coming soon" page. The live paint
// calculator has its own explicit route and never reaches here.
export default function CalculatorRoute() {
  const { slug = '' } = useParams()
  const cat = categoryBySlug(slug)

  if (cat) {
    const calcs = calcsInCategory(cat.slug)
    return (
      <div className="mx-auto max-w-5xl px-4 py-6">
        <Seo title={`${cat.name} Calculators | RenoSheets`} description={cat.blurb} path={`/calculators/${cat.slug}/`} />
        <Breadcrumbs
          items={[
            { name: 'Home', href: '/' },
            { name: cat.name, href: `/calculators/${cat.slug}/` },
          ]}
        />
        <h1 className="text-3xl">{cat.name}</h1>
        <p className="mt-1 max-w-content text-text-muted">{cat.blurb}</p>
        <div className="mt-6 grid grid-cols-2 gap-3 sm:grid-cols-3">
          {calcs.map((c) =>
            c.live ? (
              <Link key={c.slug} to={`/calculators/${c.slug}/`} className="rounded-lg border border-border bg-surface p-4 hover:shadow-sm">
                <div className="text-2xl text-brand">{c.icon}</div>
                <div className="mt-1 font-semibold text-text">{c.name}</div>
                <div className="text-sm text-text-muted">{c.tagline}</div>
              </Link>
            ) : (
              <div key={c.slug} className="rounded-lg border border-dashed border-border bg-surface-2 p-4 opacity-70">
                <div className="text-2xl text-text-subtle">{c.icon}</div>
                <div className="mt-1 font-semibold text-text-muted">{c.name}</div>
                <div className="text-xs text-text-subtle">Coming soon</div>
              </div>
            ),
          )}
        </div>
      </div>
    )
  }

  const calc = calcBySlug(slug)
  if (calc) {
    return (
      <div className="mx-auto max-w-content px-4 py-16 text-center">
        <Seo title={`${calc.name} | RenoSheets`} description={`${calc.name} — coming soon to RenoSheets.`} path={`/calculators/${calc.slug}/`} />
        <div className="text-5xl text-brand">{calc.icon}</div>
        <h1 className="mt-3 text-3xl">{calc.name}</h1>
        <p className="mt-2 text-text-muted">{calc.tagline} This one is coming soon — the paint calculator is live now.</p>
        <Link to="/calculators/paint/" className="mt-5 inline-block rounded-md bg-primary px-4 py-2 text-sm font-semibold text-on-primary">
          Try the Paint Calculator
        </Link>
      </div>
    )
  }

  return (
    <div className="mx-auto max-w-content px-4 py-16 text-center">
      <h1 className="text-3xl">Page not found</h1>
      <Link to="/" className="mt-3 inline-block text-brand-text underline">Go home</Link>
    </div>
  )
}
